"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultTransform;
function defaultTransform(state, previousState, isFulfilled, meta) {
  return isFulfilled ? state : previousState;
}


//////////////////
// WEBPACK FOOTER
// ../dist/defaultTransform.js
// module id = 896
// module chunks = 0